(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coreva-cart-upsell')) {
    customElements.define('coreva-cart-upsell', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.error = this.querySelector('[role="alert"]');
        if (!this.form || !this.button) return;
        this.submit = this.add.bind(this);
        this.form.addEventListener('submit', this.submit);
      }
      disconnectedCallback() {
        if (this.form && this.submit) this.form.removeEventListener('submit', this.submit);
      }
      async add(event) {
        event.preventDefault();
        if (this.button.disabled) return;
        const drawer = this.closest('cart-drawer');
        const checkout = drawer.querySelector('[name="checkout"]');
        const spinner = this.button.querySelector('.loading__spinner');
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        if (checkout) checkout.disabled = true;
        if (spinner) spinner.classList.remove('hidden');
        this.error.hidden = true;
        try {
          const body = new FormData(this.form);
          body.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
          body.set('sections_url', window.location.pathname);
          const response = await fetch(window.routes.cart_add_url, {
            method:'POST', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body
          });
          const state = await response.json();
          if (!response.ok || state.status) throw new Error(typeof state.description === 'string' ? state.description : this.dataset.error);
          if (!state.sections || !state.sections['cart-drawer']) {
            window.location.assign(window.routes.cart_url);
            return;
          }
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } catch (error) {
          this.error.textContent = error.message || this.dataset.error;
          this.error.hidden = false;
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
          if (checkout) checkout.disabled = false;
          if (spinner) spinner.classList.add('hidden');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
